module.exports = __webpack_public_path__ + "static/media/facilities.347683b0.png";